import _axios from 'axios';
import Cookies from 'js-cookie';
import { EnvType } from '../../constants/env.constant';
import CustomAxiosError from '../../interface/error/CustomAxiosError';
import { postLlmTokenIssueV1 } from '../../auth';
import { createSSEConnection } from './sseConnection';

const AGENT_BASE_URL = {
  production: 'https://api-llm.ats.kr-pr-midasin.com',
  staging: 'https://api-llm.ats.kr-st-midasin.com',
  staging2: 'https://api-llm.ats.kr-st2-midasin.com',
  development: 'https://api-llm.ats.kr-dv-midasin.com',
};

const getAgentBaseURL = () => {
  // eslint-disable-next-line turbo/no-undeclared-env-vars
  const env = process?.env?.NEXT_PUBLIC_ENV ?? 'development';
  // eslint-disable-next-line turbo/no-undeclared-env-vars

  return AGENT_BASE_URL[env as EnvType];
};

export const generateAxios = () => {
  const axios = _axios.create({ baseURL: getAgentBaseURL() });
  axios.defaults.withCredentials = true;

  /** 모든 요청 때마다 header에 cookie에 있는 accessToken 담기 */
  axios.interceptors.request.use(function (config) {
    const accessToken = Cookies.get('agent_access_token');
    if (!accessToken) return config;

    config.headers.Authorization = `Bearer ${accessToken}`;
    return config;
  });

  return axios;
};

// llmAxios랑 domain은 똑같지만, mrs에서 갖고 온 agentAccessToken을 Authorization 헤더에 담아야할 경우 사용하는 Axios 인스턴스
const axios = generateAxios();

export { axios };
